import {TemplateList} from "~/libs/constants/TemplateList"
import type NewsletterLocal from "~/libs/interfaces/NewsletterLocal"

export const NewsletterConfig: Record<TemplateList, NewsletterLocal[]> = {
  [TemplateList.POGGERS]: [
    {
      title: "Poggers Monthly RECAP",
      text: "Ty nejzásadnější novinky ze světa gamingu, pop kultury, internetu, esportu a technologií. Každý měsíc ve tvém inboxu!",
      intervalText: "jednou měsíčně",
      imgSrc: "/img/poggers/newsletter/pog-newsletter-01.png",
      contactListId: 895,
      contactListConsentText: "Souhlasím s <a href=\"https://www.cncenter.cz/podminky-uzivani\" target=\"_blank\">podmínkami pro užívání služby informační společnosti</a> a seznámil/a jste se s <a href=\"https://www.cncenter.cz/informace-o-zpracovani-obecna\" target=\"_blank\">informací o zpracování osobních údajů</a>.",
      secondaryContactListId: 647,
      secondaryContactListConsentText: "Chci dostávat novinky o akcích a speciálních nabídkách společnosti CZECH NEWS CENTER a.s. i jejích partnerů a <a href=\"https://www.cncenter.cz/souhlas-se-zasilanim-obchodnich-sdeleni\" target=\"_blank\">souhlasím se zpracováním osobních údajů</a>.",
      doubleOptInEmailId: 4171,
      doubleOptInSenderFrom: "poggers@news.poggers.cz",
      doubleOptInReplyTo: "poggers@news.poggers.cz",
      doubleOptInSenderName: "Poggers Monthly RECAP",
    },
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      title: "Novinky z Mateřídoušky",
      text: "Přihlas se k odběru a měj přehled o tom nejzajímavějším, co pro tebe a děti chystáme. Dozvíš se o všech atraktivních soutěžích, pošleme ti pozvánky na akce, omalovánky, recepty, tipy na knížky a filmy i nové díly oblíbených podcastů.",
      intervalText: "dvakrát měsíčně",
      imgSrc: "/img/materidouska/newsletter/mat-newsletter-01.png",
      contactListId: 893,
      contactListConsentText: "Souhlasím s <a href=\"https://www.cncenter.cz/podminky-uzivani\" target=\"_blank\">podmínkami pro užívání služby informační společnosti</a> a seznámil/a jste se s <a href=\"https://www.cncenter.cz/informace-o-zpracovani-obecna\" target=\"_blank\">informací o zpracování osobních údajů</a>.",
      secondaryContactListId: 647,
      secondaryContactListConsentText: "Chci dostávat novinky o akcích a speciálních nabídkách společnosti CZECH NEWS CENTER a.s. i jejích partnerů a <a href=\"https://www.cncenter.cz/souhlas-se-zasilanim-obchodnich-sdeleni\" target=\"_blank\">souhlasím se zpracováním osobních údajů</a>.",
      doubleOptInEmailId: 4170,
      doubleOptInSenderFrom: "materidouska@news.materidouska.cz",
      doubleOptInReplyTo: "materidouska@news.materidouska.cz",
      doubleOptInSenderName: "Novinky z Mateřídoušky",
    },
  ],
  [TemplateList.HEYFOMO]: [],
}